/*
 * 1DS JS SDK QoS plugin, 3.2.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* DateCollector.ts
* @author  Ram Thiru (ramthi@microsoft.com)
* @copyright Microsoft 2017
* File containing utility functions.
*/
import { extend, getDocument, getLocation } from "@microsoft/1ds-core-js";
export function _collectMetaTags(config) {
    /// <summary>Collect data from meta tags. Assign specific field values
    /// in the event object.Return an object that is a kvp of awa- and ms.tags. </summary>
    /// <param type='Object'>Event object whose fields will be assigned to</param>
    /// <returns type='Object'>Metatags collection/property bag</returns>
    var msTags = {};
    var awaTags = {};
    // Collect the awa-* tags.
    awaTags = _getMetaDataFromDOM("awa-", true);
    if (config.autoCapture && config.autoCapture.msTags) {
        // Collect the legacy ms.* tags and append them to the metaTags.
        msTags = _getMetaDataFromDOM("ms.", false);
    }
    return extend(true, awaTags, msTags);
}
export function _getMetaData(awaTags, coreData, metaTagName) {
    /// <summary>
    ///     If overrideValue is specified in the config that takes precedence.
    ///     However, in order to prevent the tag value found in the meta element in the dom from being used
    ///     we must extract (remove) the given tag from the pageTags collection.
    /// <param type='Object' name='awaTags'>contains meta tags</param>
    var data = _extractFieldFromObject(awaTags, metaTagName); // Do not optimize this.  We need to extract the field irrespective of whether coreData has a value or not.
    if (coreData[metaTagName]) {
        return coreData[metaTagName];
    }
    else {
        return data;
    }
}
export function _getMetaDataFromDOM(prefix, removePrefix) {
    var metaElements;
    var metaData = {};
    var doc = getDocument();
    if (doc) {
        metaElements = doc.querySelectorAll("meta");
        for (var i = 0; i < metaElements.length; i++) {
            var meta = metaElements[i];
            if (meta.name) {
                var mt = meta.name.toLowerCase();
                if (mt.indexOf(prefix) === 0) {
                    var name = removePrefix ? meta.name.replace(prefix, "") : meta.name;
                    metaData[name] = meta.content;
                }
            }
        }
    }
    return metaData;
}
export function _extractFieldFromObject(obj, fieldName) {
    /// <summary>Returns the specified field and also removes the property from the object if exists. </summary>
    /// <param type='Object'>The object</param>
    /// <param type='String'>Name of the field/property to be extracted</param>
    /// <returns type='String'>Value of the specified tag</returns>
    var fieldValue;
    if (obj && obj[fieldName]) {
        fieldValue = obj[fieldName];
        delete obj[fieldName];
    }
    return fieldValue;
}
export function _getUri(config) {
    var loc = getLocation() || {};
    return !config.coreData.requestUri ? loc.href : config.coreData.requestUri;
}
export function _getPageName(config) {
    /// <summary>
    ///  Gets the pageName from the DOM or by calling a override if set.
    /// </summary>
    if (config.callback && typeof (config.callback.pageName) === "function") {
        return config.callback.pageName();
    }
    else if (config.coreData && config.coreData.pageName) {
        return config.coreData.pageName;
    }
    else {
        var loc = getLocation() || {};
        var pagename = loc.pathname || "";
        var fragments = pagename.replace(/(^\/+|\/+$)/g, "").split("/");
        var len = fragments.length;
        if (fragments && fragments[len - 1]) {
            pagename = fragments[len - 1];
        }
        else {
            pagename = "Home";
        }
        return pagename;
    }
}
//# sourceMappingURL=DataCollector.js.map